<template>
<div>

    <nav class="navbar navbar-expand-lg navbar-dark bg-enes-blue">
        <a class="navbar-brand d-sm-block d-md-block d-lg-none d-xl-none" href="index.html">ENES</a>
        <button class="navbar-toggler icon-menu" type="button" data-toggle="collapse" data-target="#navbarsExample08" aria-controls="navbarsExample08" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon puntos"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-md-center" id="navbarsExample08">
            <ul class="navbar-nav">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle color_Blanco" href="#" id="dropdown05" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Nosotros</a>
                    <div class="dropdown-menu" aria-labelledby="dropdown05">
                        <router-link class="dropdown-item" :to="{name:'historia'}">Historia</router-link>
                        <router-link class="dropdown-item" :to="{name:'mision'}">Misión Visión</router-link>
                        <router-link class="dropdown-item" :to="{name:'organigrama'}">Organigrama</router-link>
                        <router-link class="dropdown-item" :to="{name:'directorio'}">Directorio</router-link>
                        <router-link class="dropdown-item" :to="{name:'gestion'}">Gestión 2018-2022</router-link>
                    </div>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle color_Blanco" href="#" id="dropdown05" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Cuerpos colegiados</a>
                    <div class="dropdown-menu" aria-labelledby="dropdown05">
                        <router-link class="dropdown-item" :to="{name:'consejo'}">H. Consejo Técnico</router-link>
                        <router-link class="dropdown-item" :to="{name:'comision'}">Comisiones y Comités</router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link color_Blanco"  :to="{name:'administracion'}">Administración</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link color_Blanco"  :to="{name:'enesresponde'}">ENES Responde</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link color_Blanco"  :to="{name:'igualdad'}">Igualdad de género</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link color_Blanco"  :to="{name:'contacto'}">Contacto</router-link>
                </li>
                
            </ul>
        </div>
    </nav>
    <nav class="navbar navbar-expand-lg bg-enes">
        <div class="container">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample05" aria-controls="navbarsExample05" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <img src="../assets/style/images/logos/logos_enes07.png" class="img-logo-unam img-fluid text-center" alt="ENES">
            <div class="collapse navbar-collapse justify-content-md-center" id="navbarsExample05" style=" position:relative;">
                <ul class="navbar-nav">
                    <li class="nav-item ">
                        <router-link   class="nav-link" :to="{name:'index'}">Inicio</router-link>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="dropdown05" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Licenciaturas</a>
                        <div class="dropdown-menu" aria-labelledby="dropdown05">
                          
                            <router-link class="dropdown-item"  :to="{name:'ladmision'}">Admisión</router-link>
                            <router-link v-for="(item, index) in listaOfertaA" :key="index" class="dropdown-item"  v-bind:to="'/lmszc/'+item.IdLigaInteres">
                                {{item.Titulo}}
                            </router-link>
                            
                        </div>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link"  :to="{name:'educacioncontinua'}">Educación Continua</router-link>
                    </li>
                    <li class="nav-item">
                         <router-link class="nav-link"  :to="{name:'lenguasuno'}">Lenguas</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link"  :to="{name:'alumnado'}">Alumnado</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link"  :to="{name:'investigacion'}">Investigación</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link"  :to="{name:'integrantes'}">Comunidad</router-link>
                    </li>
                </ul>
                <input v-model="txtNoticias" @keyup.enter="search_Noticias()" class="form-control search" type="text" placeholder="¿Qué deseas encontrar?">
                
            </div>
        </div>
    </nav>
    <nav class="navbar navbar-expand-lg bg-enes-mobile">
        <div class="container-fluid">
            <a class="navbar-brand img-logo-unam" href="index.html"><img src="images/logos/logos_enes07.png" class="img-fluid text-center" alt="">
            </a>
            <input class="form-control search-enes-mobile" type="text" placeholder="¿Qué deseas encontrar?">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample05" aria-controls="navbarsExample05" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse justify-content-md-center" id="navbarsExample05" style=" position:relative;">
                <div class=" row">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                        <ul class="navbar-nav">
                            <li class="nav-item active">
                                <router-link class="nav-link" :to="{name:'index'}">Inicio</router-link>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="dropdown05" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Licenciaturas</a>
                                <div class="dropdown-menu" aria-labelledby="dropdown05">
                                    <a class="dropdown-item" href="licenciaturas.html">Admisión</a>
                                
                                    
                                    <router-link v-for="(item, index) in listaOfertaA" :key="index" class="dropdown-item"  v-bind:to="'/lmszc/' + item.IdLigaInteres"> 
                                {{item.Titulo}}
                            </router-link>
                                </div>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link"  :to="{name:'educacioncontinua'}">Educación Continua</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link"  :to="{name:'lenguasuno'}">Lenguas</router-link>
                            </li>
                            <li class="nav-item">
                                 <router-link class="nav-link"  :to="{name:'alumnado'}">Alumnado</router-link>
                            </li>
                            <li class="nav-item">
                                 <router-link class="nav-link"  :to="{name:'investigacion'}">Investigación</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link"  :to="{name:'integrantes'}">Comunidad</router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                        <ul class="navbar-nav">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="dropdown05" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Nosotros</a>
                                <div class="dropdown-menu" aria-labelledby="dropdown05">
                                    <router-link class="dropdown-item"  :to="{name:'historia'}">Historia</router-link>
                                    <router-link class="dropdown-item"  :to="{name:'mision'}">Misión Visión</router-link>
                                    <router-link class="dropdown-item"  :to="{name:'organigrama'}">Organigrama</router-link>
                                    <router-link class="dropdown-item"  :to="{name:'directorio'}">Directorio</router-link>
                                    <router-link class="dropdown-item"  :to="{name:'calendario'}">Gestión </router-link>
                                </div>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="dropdown05" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Cuerpos colegiados</a>
                                <div class="dropdown-menu" aria-labelledby="dropdown05">
                                    <router-link class="dropdown-item"  :to="{name:'consejo'}">H. Consejo Técnico</router-link>
                                    <router-link class="dropdown-item"  :to="{name:'comision'}">Comisiones y Comités</router-link>
                                </div>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link"  :to="{name:'administracion'}">Administración</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link"  :to="{name:'enesresponde'}">ENES Responde</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link"  :to="{name:'igualdad'}">Igualdad de género</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link"  :to="{name:'contacto'}">Contacto</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </nav>

  	<transition name="fade" mode="out-in">
		<router-view :key="$route.fullPath"></router-view>
	</transition>


    <section class="footer ">
        <div class="medio ">
            <div class="container ">
                <div class="row align-items-center ">
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 ">
                        <figure class="text-center">
                            <img src="../assets/style/images/logo-footer.png" alt="ENES " class="img-fluid ">
                        </figure>
                    </div>
                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 ">
                        <h4 class="mb-3 ">Escuela Nacional de Estudios Superiores Unidad Mérida</h4>
                        <p>
                            Dirección: Tablaje Catastral N°6998, Carretera Mérida-Tetiz Km. 4.5, Municipio de Ucú,
                            Yucatán, México, C. P. 97357 Teléfono: 999 399 0901
                        </p>
                        <p>
                            <a href="contacto.html">Ver mapa de ubicación</a>
                        </p>
                    </div>
                    <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 ">
                        <p class="alineacion_redes ">
                            <a href="https://www.facebook.com/ENESMERIDAUNAM" class="mr-2 "><img
                                    src="../assets/style/images/facebook.png" alt="Facebook "></a>
                            <a href="https://twitter.com/ENES_Merida" class="mr-2 "><img src="../assets/style/images/twitter.png"
                                    alt="Twitter "></a>
                            <a href="https://www.youtube.com/channel/UC33xFagZ1SHY3cCH-_aj4Tw"><img
                                    src="../assets/style/images/youtube.png" alt="youtube "></a>
                        </p>
                        <p class="small ">
                            Hecho en México, Universidad Nacional Autónoma de México (UNAM), todos los derechos
                            reservados 2020. Esta página puede ser reproducida con fines no lucrativos, siempre y cuando
                            se cite la fuente completa y su dirección electrónica, y no se mutile. De
                            otra forma requiere permiso previo por escrito de la institución.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <footer class="footer-gray ">
        <div class="container ">
            <div class="row">
                <template>
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 ">

                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 ">
                        <p >   
                            <a v-for="(lista,key,index) in ListaPoliticas" :key="index" @click="Verpolitica(lista.IdPolitica)" class="text-center"  href="# ">
                                <template v-if="key == 0">
                                <!-- {{''+lista.Nombre+' '}} -->
                                <router-link :to="{name:'politica',params: {'id':lista.IdPolitica}}">{{''+lista.Nombre+' '}}</router-link>
                                </template>
                                <template v-else>
                                    <router-link :to="{name:'politica',params: {'id':lista.IdPolitica}}">{{'| '+lista.Nombre+' '}}</router-link>
                                     <!-- {{'| '+lista.Nombre+' '}} -->
                                </template>
                               </a>
                        </p>
                    </div>
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 ">
                                    
                    </div>
                </template>

                <!-- <p><a href="# ">Aviso de privacidad integral</a> | <a href="# ">Aviso de privacidad simplificado</a> |
                    <a href="# ">Aviso de privacidad integral del CCTV</a></p>
                <p><a href="# ">Aviso de privacidad simplificado del CCTV</a> | <a href="# ">Términos y condiciones</a>
                    |
                    <a href="# ">Plagio y ética</a>
                </p> -->
            </div>
        </div>
    </footer>

    <button id="backtotop" class="btn" role="button" data-toggle="tooltip" data-placement="left"><img src="../assets/style/images/iconos/ico_enes_11.png" alt="ENES"></button>

</div>
</template>

<script>
// @ is an alias to /src

import $ from 'jquery'

export default {
	name: 'Principal',
	components: {},
	data() {
		return {
            listaOfertaA:[],
            ListaPoliticas:[],
            txtNoticias:'',
		}
	},
	methods: {
        Verpolitica(id){
            if(this.$route.name == "politica"){
             
                this.bus.$emit('CambiarPolitica',id);
                
            }else{
                sessionStorage.IdPolitica = id;
                this.$router.push({ name :'politica',params:{}});
            }
            
        },
		goHome(){
            this.$router.push({ name :'index',params:{}});
            window.scrollTo(0, 0);
		},get_ListaOferta(){
             this.$http.get(
                'inicio/listaoferta/',
                {
                    params:{ RegEstatus:'A',Tipo:'lic_oferta',Entrada:100}
                }
            ).then( (res) => {
                this.listaOfertaA = res.data.ligainteres;
                this.ListaPolitica();
                //this.RutaFileLiga = res.data.RutaFile;
            });
        },get_jsIndex(){
            
            $(document).ready(function () {
                $('.nav li a').on('click', function(){
                    $('li a.activemenu').removeClass('activemenu');
                    $(this).addClass('activemenu');
                });

                $('#backtotop').click(function(){
                    $('body, html').animate({
                        scrollTop: '0px'
                    }, 800);
                });

                $(window).scroll(function(){
                    if( $(this).scrollTop() > 0){
                        $('#backtotop').slideDown(300);
                    } else {
                        $('#backtotop').slideUp(300);
                    }
                });

            });

        },

        async ListaPolitica()
        {
            await this.$http.get(
                'inicio/politicas',
                {
                    params:{}
                }
            ).then( (res) => {
                this.ListaPoliticas = res.data.Politicas;
            });
              
        },search_Noticias() {
            this.$router.push({name:'inoticia',params:{ptxtSearch:this.txtNoticias}});
        },
	},mounted() {
     this.get_ListaOferta();
        if(this.$route.name == "Master"){
             
             this.goHome();
             
        }
       this.get_jsIndex();
	},
}
</script>
